import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { ProjectDuplicateInternalPartNumberOfferPage } from '@/areas/offers/StandardPartOfferForm/pages/ProjectDuplicateInternalPartNumberOfferPage';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ sourcingLineItemId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const sourcingLineItemId = Route.useSearch({ select: (search) => search.sourcingLineItemId });
    return (
        <ProjectDuplicateInternalPartNumberOfferPage
            projectId={pathParams.projectId}
            offerId={pathParams.offerId}
            sourcingLineItemId={sourcingLineItemId}
        />
    );
}
